<div class="container-fluid">
    <div *ngIf="isDefineScreen" class="col-md-12">
        <div class="row">
            <div class="col">
                <h4>
                    <b jhiTranslate="multi-site-analysis.define.environments.label">DEFINE ENVIRONMENTS AND GROUPS</b>&nbsp;
                </h4>
            </div>
        </div>
        <div class="row pt-2">
            <label class="col-sm-3 pt-2" jhiTranslate="multi-site-analysis.environment.factor.label">Which factor defines the environment?</label>
            <div class="col-sm-3">
                <ng-select name="environmentFactorsDropdown" id="environmentFactorsDropdown" width="100%"
                           bindLabel="alias"
                           [items]="environmentFactors"
                           [(ngModel)]="selectedEnvFactor"
                           placeholder="{{ 'global.please.choose' | translate }}"
                           required>
                </ng-select>
            </div>
        </div>
        <div class="row pt-2">
            <label class="col-sm-3 pt-2" jhiTranslate="multi-site-analysis.genotype.factor.label">Which factor defines the genotype?</label>
            <div class="col-sm-3">
                <ng-select name="genotypeFactorsDropdown" id="genotypeFactorsDropdown" width="100%"
                           bindLabel="alias"
                           [items]="genotypeFactors"
                           [(ngModel)]="selectedGenotypeFactor"
                           placeholder="{{ 'global.please.choose' | translate }}"
                           required
                >
                </ng-select>
            </div>
        </div>
        <div class="row pt-2">
            <label class="col-sm-12 pt-2" jhiTranslate="multi-site-analysis.grouping.factor.label">
                Specify a grouping factor if you wish to split your environments into groups. If you do not select a grouping factor,
                all environments will be analyzed together in a single group.
            </label>
        </div>
        <div class="row pt-2">
            <label class="col-sm-3 pt-2" jhiTranslate="multi-site-analysis.environment.group.factor.label">
                Specify a factor to define environment groups:
            </label>
            <div class="col-sm-3">
                <ng-select name="groupingFactorsDropdown" id="groupingFactorsDropdown" width="100%"
                           bindLabel="alias"
                           [items]="groupingFactors"
                           [(ngModel)]="selectedGroupingFactor"
                           placeholder="{{ 'global.please.choose' | translate }}"
                           [clearable]="true"
                >
                </ng-select>
            </div>
        </div>
        <br/>
        <div class="row col-md-12">
            <h4>
                <b jhiTranslate="multi-site-analysis.factors.and.variates.label">REVIEW THE FACTORS AND VARIATES IN THE SELECTED DATASET</b>&nbsp;
            </h4>
        </div>
        <br/>
        <div class="row col-md-12">
            <h4>
                <span class="bms-factors" style="color: #39B54A; font-size: 18px;"></span>&nbsp;<b jhiTranslate="multi-site-analysis.factors.label">FACTORS</b>
            </h4>
        </div>
        <div class="row col-md-12">
            <span jhiTranslate="multi-site-analysis.factors.text"></span>
        </div>
        <div class="row pt-2">
            <div class="col-md-12">
                <table class="table table-striped table-bordered table-curved table-fixed" style="max-height: 170px; margin-bottom: 0px;" *ngIf="genotypeFactors.length else nodata">
                    <thead>
                    <tr>
                        <th><span jhiTranslate="multi-site-analysis.table.headers.name">NAME</span></th>
                        <th><span jhiTranslate="multi-site-analysis.table.headers.description">DESCRIPTION</span></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let variable of genotypeFactors; index as index">
                        <td>{{variable.alias}}</td>
                        <td>{{variable.description}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <br/>
        <div class="row col-md-12">
            <h4>
                <span class="bms-variates" style="color: #B8D433; font-size: 20px;"></span><b jhiTranslate="multi-site-analysis.traits.label">TRAITS</b>
            </h4>
        </div>
        <div class="row col-md-12">
            <span jhiTranslate="multi-site-analysis.traits.text"></span>
        </div>
        <div class="row pt-2">
            <div class="col-md-12">
                <table class="table table-striped table-bordered table-curved table-fixed mb-0" *ngIf="analyzedTraits.length else nodata">
                    <thead>
                    <tr>
                        <th><input class="form-check-input" type="checkbox" title="{{ 'global.select.all.items' | translate }}" [checked]="isAllAnalyzedTraitsSelected()" (click)="onSelectAllAnalyzedTraits()"/></th>
                        <th><span jhiTranslate="multi-site-analysis.table.headers.name">NAME</span></th>
                        <th><span jhiTranslate="multi-site-analysis.table.headers.description">DESCRIPTION</span></th>
                        <th><span jhiTranslate="multi-site-analysis.table.headers.tested.in">TESTED IN</span></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let trait of analyzedTraits; trackBy: variableTrackId; index as index">
                        <td><input class="form-check-input" type="checkbox" [checked]="isAnalyzedTraitSelected(trait)" (click)="toggleTraitSelect(trait)"></td>
                        <td>{{trait.name}}</td>
                        <td>{{trait.description}}</td>
                        <td>{{trait.testedIn}} of {{numberOfInstances}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div *ngIf="analyzedTraits.length" class="row pt-3">
            <div class="col-md-12">
                <div class="form-check-inline">
                    <input type="checkbox" class="form-check-input ms-1" [checked]="isAllAnalyzedTraitsSelected()" (click)="onSelectAllAnalyzedTraits()">
                    <label class="form-check-label ms-1">
                        Select all
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!isDefineScreen" class="col-md-12">
        <div class="row col-md-12">
            <h4>
                <b jhiTranslate="multi-site-analysis.define.environments.label">DETAILS OF SELECTED DATASET</b>&nbsp;
            </h4>
        </div>
        <br/>
        <div class="row mb-1">
            <div class="col-md-3">
                <label class="col-sm-5"><b jhiTranslate="multi-site-analysis.dataset.label">Dataset</b></label>
                <label class="col-sm-7">{{meansDataset.datasetName}}</label>
            </div>
            <div class="col-md-6">
                <label class="col-sm-5"><b jhiTranslate="multi-site-analysis.environment.defined.by.label">Environment is Defined By:</b></label>
                <label class="col-sm-7">{{selectedEnvFactor.alias}}</label>
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-md-3">
                <label class="col-sm-5 p-0"><b jhiTranslate="multi-site-analysis.data.source.label">Data Source:</b></label>
                <label class="col-sm-7">{{studyName}}</label>
            </div>
            <div class="col-md-6">
                <label class="col-sm-5"><b jhiTranslate="multi-site-analysis.environment.grouping.factor.label">Environment Grouping Factor:</b></label>
                <label class="col-sm-7">{{getEnvironmentGroupingFactorText()}}</label>
            </div>
        </div>
        <br/>
        <div class="row col-md-12">
            <h4>
                <span class="bms-dataset" style="color: #FF4612; font-size: 15px;"></span>&nbsp;<b jhiTranslate="multi-site-analysis.adjusted.means.dataset.label">ADJUSTED MEANS DATASET</b>&nbsp;
            </h4>
        </div>
        <div class="row col-md-12">
            <span jhiTranslate="multi-site-analysis.adjusted.means.dataset.text"></span>
        </div>
        <div class="row pt-2">
            <div class="col-md-12">
                <div class="table-responsive custom-scroll-style">
                    <table class="table table-striped table-bordered table-curved mb-0" *ngIf="instances.length else nodata">
                        <thead>
                        <tr>
                            <th><input type="checkbox" class="form-check-input" title="{{ 'global.select.all.items' | translate }}" [checked]="isAllInstancesSelected()" (click)="onSelectAllInstances()"/></th>
                            <th><span jhiTranslate="multi-site-analysis.table.headers.trial.instance">TRIAL_INSTANCE</span></th>
                            <th *ngIf="showEnvironmentFactorColumn()"><span>{{selectedEnvFactor.alias}}</span></th>
                            <th *ngIf="showEnvironmentGroupingFactorColumn()"><span>{{selectedGroupingFactor.alias}}</span></th>
                            <th *ngFor="let trait of adjustedMeansTraits; trackBy: variableTrackId; index as index">
                                <span>{{trait.name}}</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let instance of instances; trackBy: instanceTrackId; index as index">
                            <td><input type="checkbox" class="form-check-input" [checked]="isInstanceSelected(instance)" (click)="toggleInstanceSelect(instance)"></td>
                            <td>{{instance.instanceNumber}}</td>
                            <td *ngIf="showEnvironmentFactorColumn()"><span>{{getFactorValue(instance.instanceNumber, selectedEnvFactor)}}</span></td>
                            <td *ngIf="showEnvironmentGroupingFactorColumn()"><span>{{getFactorValue(instance.instanceNumber, selectedGroupingFactor)}}</span></td>
                            <td *ngFor="let trait of adjustedMeansTraits">
                                {{getHeritabilityString(trait, instance)}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div *ngIf="analyzedTraits.length" class="row pt-3">
            <div class="col-md-12">
                <div class="form-check-inline d-flex align-items-center">
                    <input type="checkbox" class="form-check-input" [checked]="isAllInstancesSelected()" (click)="onSelectAllInstances()">
                    <label class="form-check-label ms-1" jhiTranslate="global.select.all.items">
                        Select all
                    </label>
                </div>
            </div>
        </div>
        <br/>
        <div class="row col-md-12">
            <span jhiTranslate="multi-site-analysis.select.traits.label"></span>
        </div>
        <div class="row pt-2">
            <div class="col-md-12">
                <table class="table table-striped table-bordered table-curved mb-0" *ngIf="adjustedMeansTraits.length else nodata">
                    <thead>
                    <tr>
                        <th><input class="form-check-input" type="checkbox" title="{{ 'global.select.all.items' | translate }}" [checked]="isAllAdjustedMeansSelected()" (click)="onSelectAllAdjustedMeans()"/></th>
                        <th><span jhiTranslate="multi-site-analysis.table.headers.name">NAME</span></th>
                        <th><span jhiTranslate="multi-site-analysis.table.headers.description">DESCRIPTION</span></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let trait of adjustedMeansTraits; trackBy: variableTrackId; index as index">
                        <td><input class="form-check-input"  type="checkbox" [checked]="isAdjustedMeanSelected(trait)" (click)="toggleAdjustedMeanSelect(trait)"></td>
                        <td>{{trait.name}}</td>
                        <td>{{trait.description}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div *ngIf="analyzedTraits.length" class="row pt-3">
            <div class="col-md-12">
                <div class="form-check-inline d-flex align-items-center">
                    <input type="checkbox" class="form-check-input" [checked]="isAllAdjustedMeansSelected()" (click)="onSelectAllAdjustedMeans()">
                    <label class="form-check-label ms-1" style="padding-top: 2px;" jhiTranslate="global.select.all.items">
                        Select all
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer mt-3">
        <div class="row">
            <div class="col d-flex justify-content-end">
                <button *ngIf="isDefineScreen" (click)="resetDefineScreenValues($event)" type="button" class="btn btn-secondary" value="resetDefineScreenValues"
                        jhiTranslate="reset">
                    Reset
                </button>
                <button *ngIf="isDefineScreen" (click)="next($event)" type="button" class="btn btn-primary ms-2" value="next"
                        jhiTranslate="next">
                    Next
                </button>
                <button *ngIf="!isDefineScreen" (click)="back($event)" type="button" class="btn btn-secondary ms-2" value="back"
                        jhiTranslate="back">
                    Back
                </button>
                <button *ngIf="!isDefineScreen" (click)="resetDownloadScreenValues($event)" type="button" class="btn btn-secondary ms-2" value="resetDownloadScreenValues"
                        jhiTranslate="reset">
                    Reset
                </button>
                <button *ngIf="!isDefineScreen" (click)="download($event)" class="btn btn-primary ms-2"
                        [disabled]="isLoading">
                    <span *ngIf="isLoading" class="throbber throbber-btn"></span>
					<span jhiTranslate="multi-site-analysis.download.button">Download Input Files</span>
                </button>
            </div>
        </div>

    </div>
    <br/>
</div>
<br/>
<br/>
<ng-template #nodata>
    <table class="table table-striped table-bordered table-curved">
        <thead><tr><th></th></tr></thead><tbody>
    <tr><td jhiTranslate="no.data"></td></tr></tbody>
    </table>
</ng-template>
